import { useState, useEffect, useRef } from 'react'
import styles from './styles/EditorialBadges.css'
import classNames from 'classnames'
import { cleanStatus, groupSimilarNotices, sortEditorialNotices } from './EditorialNotices'
import Badge from './Badge'
import Fade from './Fade'
import useClickOut from '../../hooks/useClickOut'

const RemainingTooltipBadges = ({ notices }) => {
  return (
    <span className={styles.layout}>

      {groupSimilarNotices(notices).map(({ date, noticeDoi, status, doi }, i) => (
        <a key={i} target='_blank' rel='noopener noreferrer' href={(noticeDoi || doi) && `https://doi.org/${noticeDoi || doi}`}>
          <Badge className={classNames(styles.pill, {
            [styles.withdrawn]: status === 'removed',
            [styles.retracted]: status === 'Retracted',
            [styles.withdrawn]: status === 'Withdrawn',
            [styles.correction]: status === 'Has correction',
            [styles.erratum]: status === 'Has erratum',
            [styles.concern]: status === 'Has expression of concern'
          })}
          >
            {cleanStatus(status)} {date && (`${date}`)}
          </Badge>
        </a>
      ))}
    </span>
  )
}

const EditorialBadges = ({ notices }) => {
  const [firstNotice, setFirstNotice] = useState(null)
  const [remainingNotices, setRemainingNotices] = useState(null)
  const [showDropdown, setShowDropdown] = useState(false)
  const ref = useRef(null)

  useClickOut(ref, showDropdown, () => setShowDropdown(false))

  useEffect(() => {
    const sortedAndGroupedNotices = sortEditorialNotices(groupSimilarNotices(notices))
    if (sortedAndGroupedNotices && sortedAndGroupedNotices.length > 0) {
      setFirstNotice(sortedAndGroupedNotices[0])
      setRemainingNotices(sortedAndGroupedNotices.slice(1))
    }
  }, [])

  if (!firstNotice) {
    return null
  }

  return (
    <span className={styles.layout}>
      <a target='_blank' rel='noopener noreferrer' href={(firstNotice.noticeDoi || firstNotice.doi) && `https://doi.org/${firstNotice.noticeDoi || firstNotice.doi}`}>
        <Badge className={classNames({
          [styles.withdrawn]: firstNotice.status === 'removed',
          [styles.retracted]: firstNotice.status === 'Retracted',
          [styles.withdrawn]: firstNotice.status === 'Withdrawn',
          [styles.correction]: firstNotice.status === 'Has correction',
          [styles.erratum]: firstNotice.status === 'Has erratum',
          [styles.concern]: firstNotice.status === 'Has expression of concern'
        })}
        >
          {cleanStatus(firstNotice.status)} {firstNotice.date && (`${firstNotice.date}`)}
        </Badge>
      </a>
      {remainingNotices.length > 0 && (
        <div className={styles.remainingNotices} ref={ref}>
          <span onMouseOver={() => setShowDropdown(!showDropdown)} onClick={() => setShowDropdown(!showDropdown)}>+{remainingNotices.length}</span>
          {showDropdown &&
            <ul className={styles.dropdown}>
              <Fade show={showDropdown}>
                <RemainingTooltipBadges notices={remainingNotices} />
              </Fade>
            </ul>}
        </div>
      )}
    </span>
  )
}

export default EditorialBadges
